import React, { useContext } from "react";
import { makeGet } from "@culturehq/client";

import { usePagedEntity } from "app/hooks";

import * as CHQ from "chq";

type UsersState = {
  allUsersFetched: boolean;
  onAllUsersRequested: () => void;
  onAutocompleteUsers: (_query: string) => void;
  onNextUserPageRequested: () => void;
  onUsersRequested: (_userIds: number[]) => void;
  users: { [key: number]: CHQ.User };
};

const UsersContext = React.createContext<UsersState>({
  allUsersFetched: false,
  onAllUsersRequested: () => {},
  onAutocompleteUsers: () => {},
  onNextUserPageRequested: () => {},
  onUsersRequested: () => {},
  users: {}
});

const onFetchPage = (page: number) => makeGet("/users", { page });
const onFetchEntity = (userId: number) => makeGet(`/users/${userId}`);
const onFetchAutocomplete = (query: string) => makeGet("/autocomplete/users", { query });

export const UsersProvider: React.FC = ({ children }) => {
  const value = usePagedEntity("user", onFetchPage, onFetchEntity, onFetchAutocomplete);

  return (
    <UsersContext.Provider value={value as UsersState}>
      {children}
    </UsersContext.Provider>
  );
};

export const useUsers = () => useContext(UsersContext);
